import { RequestListingPage } from "@/components/request-listing-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/eap/request/$listingId/$variantId")({
  component: Page,
});

function Page() {
  const { listingId, variantId } = Route.useParams();

  return <RequestListingPage listingId={listingId} variantId={variantId} />;
}
